abstract class BasePolyfill {
  public execute: boolean;
  public polyfill: () => Promise<any>;
}

export { BasePolyfill };
